
import Vue from "vue";
import { mapActions, mapGetters, mapMutations } from "vuex";
import {
  GET_USER_DETAILS,
  USER_DETAILS_BY_ID,
  USER_PROFILE,
  USER_PROFILE_BY_ID
} from "@/store/modules/auth/constants";
import { GET_ROLE_BY_NAME } from "@/store/modules/common/constants";
import GoBackHeader from "@/components/shared/GoBackHeader.vue";
import { get_name_initials } from "@/utils/global";
import { get_color_by_name, get_random_color_hash } from "@/utils/colors";
import HighlightsAwards from "@/components/shared/view_profile/HighlightsAwards.vue";
import EducationDetails from "@/components/shared/view_profile/EducationDetails.vue";
import CertificationDetails from "@/components/shared/view_profile/CertificationDetails.vue";
import WorkExperience from "@/components/shared/view_profile/WorkExperience.vue";
import Personality from "@/components/shared/view_profile/Personality.vue";
import SkillsGroup from "@/components/shared/SkillsGroup.vue";
import SkillsChips from "@/components/shared/SkillsChips.vue";
import ProfilePicture from "@/components/shared/view_profile/ProfilePicture.vue";
import UserName from "@/components/shared/view_profile/UserName.vue";
import UserRating from "@/components/shared/view_profile/UserRating.vue";
import UserDesignation from "@/components/shared/view_profile/UserDesignation.vue";
import {
  CANDIDATE_VIEW_PAYLOAD,
  INTERVIEW_LISTING,
  POKE_CANDIDATE,
  POKE_CANDIDATE_LOADING
} from "@/store/modules/recruiter/constants";
import { GET_JOB_MATCH_AGAINST_JOB_ID } from "@/store/modules/candidates/constants";
import { ROOT_ERROR, ROOT_NOTIFICATION } from "@/store/modules/root/constants";
import SkillMatch from "@/components/shared/view_profile/SkillMatch.vue";
import ProficiencyReport from "@/components/shared/ProficiencyReport.vue";
import UserExperience from "@/components/shared/view_profile/UserExperience.vue";
import {
  InterviewListingPayload,
  PokeCandidatePayload
} from "@/store/modules/recruiter/interfaces";
import { get_interview_status_msg } from "@/utils/interviews";
import { SkillGap as SG } from "@/interfaces/responses/skill_gap";
import SkillGap from "@/components/shared/view_profile/SkillGap.vue";
import { SITE_DIRECTION } from "@/store/modules/common/constants";
import UserProfileLoader from "@/components/shared/UserProfileLoader.vue";
import { UserProfileData } from "@/store/modules/common/interfaces";
import {
  INIT_AI_INTERVIEW_INVITES,
  SCHEDULE_AI_INTERVIEW_INVITE
} from "@/store/modules/recruiter_ai_interviews/constants";
import {
  connect_ms_teams,
  get_ms_teams_connection_status,
  generate_ms_teams_link,
  send_interviewer_meeting_invite
} from "@/store/apis/recruiter";
import {
  generate_guidelines,
  generate_questions,
  get_latest_interview_report,
  upsert_interview_report
} from "@/store/apis/ml_interview";
import { get_job_by_id } from "@/store/apis/common";

export default Vue.extend({
  name: "ViewCandidateProfile",
  components: {
    SkillGap,
    UserExperience,
    SkillMatch,
    UserDesignation,
    UserRating,
    UserName,
    ProfilePicture,
    SkillsChips,
    SkillsGroup,
    Personality,
    WorkExperience,
    CertificationDetails,
    EducationDetails,
    HighlightsAwards,
    GoBackHeader,
    UserProfileLoader,
    ProficiencyReport
  },
  data() {
    return {
      loading: true,
      job_details_loading: true,
      active_skill_group: "",
      designation: null,
      job_details: null as null | SG.Root,
      data: {} as UserProfileData,
      interview_status_loading: false,
      interview_status_msg: "",
      interview_exist: false,
      interview_status: "" as string,
      ai_interview_completed: false,
      ai_completion_check_failed: false,
      social_icons: {
        linkedin: require("@/assets/logos/linkedin-3.svg"),
        twitter: require("@/assets/logos/twitter.svg"),
        instagram: require("@/assets/logos/instagram.svg"),
        facebook: require("@/assets/logos/facebook.svg")
      },
      job_id: null as number | null,
      show_ai_dialog: false,
      show_person_dialog: false,
      ms_teams_connect_loading: false,
      ms_teams_connected: false,
      duration_options: [15, 30, 45, 60, 90],
      ai_form: {
        duration_minutes: 30,
        scheduled_at: ""
      },
      person_form: {
        interviewer_email: "",
        ms_teams_link: "",
        ms_teams_meeting_id: "",
        ms_teams_join_meeting_id: "",
        ms_teams_meeting_passcode: "",
        duration_minutes: 30,
        scheduled_at: ""
      },
      person_invite_submitting: false,
      person_invite_status_text: ""
    };
  },
  watch: {
    get_site_direction() {
      this.set_interview_message();
    },
    async show_person_dialog(value: boolean) {
      if (!value) return;
      await this.load_ms_teams_connection_status();
    }
  },
  computed: {
    ...mapGetters("recruiter", {
      get_candidate_view_payload: CANDIDATE_VIEW_PAYLOAD,
      get_poke_candidate_loading: POKE_CANDIDATE_LOADING
    }),
    ...mapGetters("auth", {
      user_details: GET_USER_DETAILS,
      user_profile: USER_PROFILE
    }),
    ...mapGetters("common", {
      get_role_by_name: GET_ROLE_BY_NAME,
      get_site_direction: SITE_DIRECTION
    }),
    ai_invite_exist(): boolean {
      const userStr = sessionStorage.getItem("user");
      const jobStr = sessionStorage.getItem("job");
      const candidate_id = userStr ? parseInt(userStr) : NaN;
      const job_id = jobStr ? parseInt(jobStr) : NaN;
      if (isNaN(candidate_id)) return false;
      const invites =
        this.$store.getters["recruiter_ai_interviews/AI_INTERVIEW_INVITES"] || [];
      return invites.some(
        (i: any) =>
          (i.interview_type || "ai") === "ai" &&
          i.candidate_id === candidate_id &&
          i.job_id === (isNaN(job_id) ? null : job_id) &&
          i.status === "scheduled"
      );
    },
    person_invite_exist(): boolean {
      const userStr = sessionStorage.getItem("user");
      const jobStr = sessionStorage.getItem("job");
      const candidate_id = userStr ? parseInt(userStr) : NaN;
      const job_id = jobStr ? parseInt(jobStr) : NaN;
      if (isNaN(candidate_id)) return false;
      const invites =
        this.$store.getters["recruiter_ai_interviews/PERSON_INTERVIEW_INVITES"] || [];
      return invites.some(
        (i: any) =>
          i.candidate_id === candidate_id &&
          i.job_id === (isNaN(job_id) ? null : job_id) &&
          i.status === "scheduled"
      );
    },
    canSchedulePersonInterview(): boolean {
      return (
        !!this.ai_invite_exist &&
        (!!this.ai_interview_completed || !!this.ai_completion_check_failed)
      );
    }
  },
  // Validating route param type is int on router enter
  beforeRouteEnter(to, from, next) {
    const user = sessionStorage.getItem("user");
    const upload = sessionStorage.getItem("upload");
    if (!user || !upload) next(false);
    else next();
  },

  async created() {
    await this.init_data();
  },
  methods: {
    ...mapMutations({
      root_error: ROOT_ERROR,
      root_notification: ROOT_NOTIFICATION
    }),
    ...mapActions("candidate", {
      fetch_skill_gap: GET_JOB_MATCH_AGAINST_JOB_ID
    }),
    ...mapActions("recruiter", {
      poke_candidate: POKE_CANDIDATE,
      fetch_interview: INTERVIEW_LISTING
    }),
    get_color_by_name,
    get_random_color_hash,
    get_name_initials,
    ...mapActions("auth", {
      fetch_profile_by_id: USER_PROFILE_BY_ID,
      fetch_user_by_id: USER_DETAILS_BY_ID
    }),
    async init_data() {
      this.loading = true;
      this.job_details_loading = true;
      this.interview_status_loading = true;
      await this.$store.dispatch(`recruiter_ai_interviews/${INIT_AI_INTERVIEW_INVITES}`);
      const cv_id = parseInt(sessionStorage.getItem("user") ?? "");
      const job_id = parseInt(sessionStorage.getItem("job") ?? "");
      this.job_id = job_id;
      const upload_response_id = sessionStorage.getItem("upload") ?? "";
      if (isNaN(cv_id) || !upload_response_id) {
        this.root_error("Invalid Job");
        await this.$router.push("/recruiter");
        return;
      }
      // Getting user profile fetched from cv
      const user_profile = await this.fetch_profile_by_id(cv_id);
      // Getting user details
      const user_details = await this.fetch_user_by_id(cv_id);
      this.data = {
        user: user_details,
        profile: user_profile
      };
      this.loading = false;
      // Fetching job match & job gap
      if (job_id) {
        const skill_gap = await this.fetch_skill_gap({
          job_id: job_id,
          cv_id: upload_response_id
        });
        if (skill_gap) this.job_details = skill_gap;
        else {
          this.root_error("Failed to get job match & job match");
        }
        await this.fetch_interview_details(job_id, user_details.id);
      }
      await this.syncAiInterviewCompletionStatus();
      this.job_details_loading = false;
      this.interview_status_loading = false;
    },
    async syncAiInterviewCompletionStatus() {
      const userStr = sessionStorage.getItem("user");
      const jobStr = sessionStorage.getItem("job");
      const candidate_id = userStr ? parseInt(userStr) : NaN;
      const job_id = jobStr ? parseInt(jobStr) : NaN;
      if (isNaN(candidate_id)) {
        this.ai_interview_completed = false;
        return;
      }
      try {
        const resp = await get_latest_interview_report(
          candidate_id,
          "ai",
          isNaN(job_id) ? null : job_id
        );
        const report = resp?.data?.data;
        const normalizedStatus = String(report?.status || "").toLowerCase().trim();
        const parseMaybeJson = (value: any) => {
          if (!value) return value;
          if (typeof value === "object") return value;
          if (typeof value === "string") {
            try {
              return JSON.parse(value);
            } catch (_e) {
              return value;
            }
          }
          return value;
        };
        const aiReport = parseMaybeJson(report?.ai_report);
        const aiTranscript = parseMaybeJson(report?.ai_transcript);
        const hasAiReport =
          aiReport && typeof aiReport === "object" && Object.keys(aiReport).length > 0;
        const hasAiTranscript =
          Array.isArray(aiTranscript) && aiTranscript.length > 0;
        this.ai_interview_completed = !!(
          report &&
          (normalizedStatus === "completed" ||
            normalizedStatus === "generated" ||
            hasAiTranscript ||
            hasAiReport)
        );
        this.ai_completion_check_failed = false;
      } catch (_e) {
        this.ai_interview_completed = false;
        this.ai_completion_check_failed = true;
      }
    },
    set_interview_message() {
      if (!this.interview_status) {
        this.interview_status_msg = this.$t(
          "shared.interview.invite"
        ).toString();
        return;
      }
      this.interview_status_msg =
        this.$t("shared.interview.interview") +
        get_interview_status_msg(
          this.interview_status,
          this.user_details.role_id
        );
    },
    update_skill_group(skill_group: string) {
      if (skill_group === this.active_skill_group) this.active_skill_group = "";
      else this.active_skill_group = skill_group;
    },
    transform_poke_icon(icon: HTMLElement): HTMLElement {
      for (let node of icon.children)
        node.setAttribute("stroke", get_color_by_name("white"));
      return icon;
    },
    transform_resume_icon(icon: HTMLElement): HTMLElement {
      for (let node of icon.children) {
        node.setAttribute("fill", get_color_by_name("white"));
        node.setAttribute("stroke", get_color_by_name("grey"));
      }
      return icon;
    },
    /**
     * FUnction to send API request to poke candidate
     */
    async _poke_candidate() {
      const cv_id = parseInt(sessionStorage.getItem("user") ?? "");
      const job_id = parseInt(sessionStorage.getItem("job") ?? "");
      // Validating candidate_id and job_id
      if (isNaN(cv_id) || isNaN(job_id)) {
        this.root_error(this.$t("errors.job-not-exist"));
        return;
      }
      const payload: PokeCandidatePayload = {
        candidate_id: cv_id,
        job_id: job_id,
        type: "interview_invite"
      };
      await this.poke_candidate(payload);
      await this.fetch_interview_details(job_id, cv_id);
    },
    async fetch_interview_details(job_id: number, uid: number) {
      this.interview_status_loading = true;
      const interview_payload: InterviewListingPayload = {
        job_id: job_id,
        candidate_id: uid,
        interviewed_by: this.user_details.id
      };
      const result = await this.fetch_interview(interview_payload);
      if (result.length > 0) {
        this.interview_status = result[0].interview_status;
        this.interview_exist = true;
        this.interview_status_msg =
          this.$t("shared.interview.interview") +
          get_interview_status_msg(
            result[0].interview_status,
            this.user_details.role_id
          );
      } else
        this.interview_status_msg = this.$t(
          "shared.interview.invite"
        ).toString();
      this.interview_status_loading = false;
    }
    ,
    async schedule_ai_interview_invite() {
      const userStr = sessionStorage.getItem("user");
      const jobStr = sessionStorage.getItem("job");
      const upload_response_id = sessionStorage.getItem("upload") ?? null;
      const candidate_id = userStr ? parseInt(userStr) : NaN;
      const job_id = jobStr ? parseInt(jobStr) : NaN;

      if (isNaN(candidate_id)) {
        this.root_error(this.$t("errors.job-not-exist"));
        return;
      }
      if (!this.ai_form.scheduled_at) {
        this.root_notification("Please select interview date and time.");
        return;
      }
      if (!this.ai_form.duration_minutes) {
        this.root_notification("Please select interview duration.");
        return;
      }

      this.$store.dispatch(
        `recruiter_ai_interviews/${INIT_AI_INTERVIEW_INVITES}`
      );
      const roleFromStore =
        this.$store?.state?.recruiter?.view_candidates_dynamically?.job_title || "";
      const jobRole = roleFromStore || (isNaN(job_id) ? "Interview Role" : `Job #${job_id}`);
      const roomSeed = `${candidate_id}_${isNaN(job_id) ? "nojob" : job_id}_${new Date(
        this.ai_form.scheduled_at
      ).getTime()}`;
      const platformRoomId = `hcms-final-${roomSeed}`;

      const invite = await this.$store.dispatch(
        `recruiter_ai_interviews/${SCHEDULE_AI_INTERVIEW_INVITE}`,
        {
          interview_type: "ai",
          job_id: isNaN(job_id) ? null : job_id,
          job_role: jobRole,
          candidate_id,
          upload_response_id,
          candidate_name:
            this.data?.profile?.profile?.personal_details?.name &&
            Object.keys(this.data.profile.profile.personal_details.name).length > 0
              ? Object.values(this.data.profile.profile.personal_details.name)
                  .filter((v: any) => v)
                  .join(" ")
              : "Candidate",
          candidate_role: this.designation || "Candidate",
          avatar_uri: this.data?.user?.avatar_uri ?? null,
          platform_room_id: platformRoomId,
          duration_minutes: Number(this.ai_form.duration_minutes),
          scheduled_at: new Date(this.ai_form.scheduled_at).toISOString()
        }
      );

      if (invite) {
        this.root_notification(
          this.$t("shared.interview.ai-interview-invite-scheduled").toString()
        );
        this.closeAiDialog();
        await this.$router.push({ path: "/recruiter/interviews/ai-agent" });
        return;
      }

      this.root_notification(
        this.$t("shared.interview.ai-interview-invite-already").toString()
      );
    },
    closeAiDialog() {
      this.show_ai_dialog = false;
      this.ai_form = {
        duration_minutes: 30,
        scheduled_at: ""
      };
    },
    closePersonDialog() {
      this.show_person_dialog = false;
      this.ms_teams_connect_loading = false;
      this.ms_teams_connected = false;
      this.person_invite_submitting = false;
      this.person_invite_status_text = "";
      this.person_form = {
        interviewer_email: "",
        ms_teams_link: "",
        ms_teams_meeting_id: "",
        ms_teams_join_meeting_id: "",
        ms_teams_meeting_passcode: "",
        duration_minutes: 30,
        scheduled_at: ""
      };
    },
    async connect_ms_teams_account() {
      const base64UrlEncode = (input: ArrayBuffer | Uint8Array): string => {
        const bytes = input instanceof Uint8Array ? input : new Uint8Array(input);
        let binary = "";
        for (let i = 0; i < bytes.byteLength; i++) {
          binary += String.fromCharCode(bytes[i]);
        }
        return btoa(binary).replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/g, "");
      };
      const randomString = (length = 64): string => {
        const charset =
          "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-._~";
        const random = new Uint8Array(length);
        window.crypto.getRandomValues(random);
        let out = "";
        for (let i = 0; i < random.length; i++) {
          out += charset[random[i] % charset.length];
        }
        return out;
      };
      const clientId = process.env.VUE_APP_MS_TEAMS_CLIENT_ID;
      const tenantId = process.env.VUE_APP_MS_TEAMS_TENANT_ID;
      if (!clientId || !tenantId) {
        this.root_notification(
          "Microsoft Teams OAuth is not configured on frontend."
        );
        return;
      }
      this.ms_teams_connect_loading = true;
      const redirectUri = `${window.location.origin}/ms-teams-oauth-callback.html`;
      const codeVerifier = randomString(96);
      const digest = await window.crypto.subtle.digest(
        "SHA-256",
        new TextEncoder().encode(codeVerifier)
      );
      const codeChallenge = base64UrlEncode(digest);
      const scope = encodeURIComponent(
        "offline_access openid profile User.Read OnlineMeetings.ReadWrite"
      );
      const authUrl = `https://login.microsoftonline.com/${tenantId}/oauth2/v2.0/authorize?client_id=${encodeURIComponent(
        clientId
      )}&response_type=code&redirect_uri=${encodeURIComponent(
        redirectUri
      )}&response_mode=query&scope=${scope}&state=ms_teams_connect&code_challenge_method=S256&code_challenge=${encodeURIComponent(
        codeChallenge
      )}`;

      const popup = window.open(
        authUrl,
        "msTeamsOAuth",
        "width=540,height=720,menubar=no,toolbar=no,location=no,status=no,resizable=yes,scrollbars=yes"
      );
      if (!popup) {
        this.ms_teams_connect_loading = false;
        this.root_notification("Popup blocked. Please allow popups and try again.");
        return;
      }

      try {
        const code: string = await new Promise((resolve, reject) => {
          const timeout = window.setTimeout(() => {
            window.removeEventListener("message", onMessage);
            reject(new Error("timeout"));
          }, 120000);
          const onMessage = (event: MessageEvent) => {
            if (event.origin !== window.location.origin) return;
            const payload = event.data || {};
            if (payload.source !== "ms-teams-oauth") return;
            window.clearTimeout(timeout);
            window.removeEventListener("message", onMessage);
            if (payload.error) {
              reject(new Error(payload.error_description || payload.error));
              return;
            }
            if (!payload.code) {
              reject(new Error("No authorization code received."));
              return;
            }
            resolve(payload.code);
          };
          window.addEventListener("message", onMessage);
        });

        await connect_ms_teams({
          code,
          redirect_uri: redirectUri,
          code_verifier: codeVerifier
        });
        this.ms_teams_connected = true;
        this.root_notification("Microsoft Teams connected successfully.");
      } catch (e) {
        const err: any = e;
        const message =
          err?.response?.data?.message ||
          err?.response?.data?.error ||
          err?.message ||
          "Failed to connect Microsoft Teams account.";
        this.root_notification(message);
      } finally {
        this.ms_teams_connect_loading = false;
      }
    },
    async load_ms_teams_connection_status() {
      try {
        const resp = await get_ms_teams_connection_status();
        this.ms_teams_connected = !!resp?.data?.data?.connected;
      } catch (_e) {
        this.ms_teams_connected = false;
      }
    },
    async resolveMlJdText(this: any, jobId: number, roleFallback: string): Promise<string> {
      if (!jobId || Number.isNaN(jobId)) return String(roleFallback || "").trim();
      try {
        const resp = await get_job_by_id(jobId);
        const payload = resp?.data?.data || resp?.data || {};
        const description = String(
          payload?.job_description || payload?.description || payload?.jd_text || ""
        ).trim();
        if (description) return description;
      } catch (_e) {
        // ignore and fallback
      }
      return String(roleFallback || "").trim();
    },
    async resolveInviteJobRole(this: any, jobId: number, fallbackRole: string): Promise<string> {
      if (!jobId || Number.isNaN(jobId)) return String(fallbackRole || "").trim();
      try {
        const resp = await get_job_by_id(jobId);
        const payload = resp?.data?.data || resp?.data || {};
        const title = String(payload?.job_title || payload?.title || "").trim();
        if (title) return title;
      } catch (_e) {
        // ignore and fallback
      }
      const normalizedFallback = String(fallbackRole || "").trim();
      if (/^job\s*#\s*\d+$/i.test(normalizedFallback)) return "Interview Role";
      return normalizedFallback;
    },
    async schedule_person_interview_invite() {
      if (this.person_invite_submitting) return;
      const userStr = sessionStorage.getItem("user");
      const jobStr = sessionStorage.getItem("job");
      const upload_response_id = sessionStorage.getItem("upload") ?? null;
      const candidate_id = userStr ? parseInt(userStr) : NaN;
      const job_id = jobStr ? parseInt(jobStr) : NaN;

      if (isNaN(candidate_id)) {
        this.root_error(this.$t("errors.job-not-exist"));
        return;
      }
      if (!this.canSchedulePersonInterview) {
        this.root_notification(
          "AI interview invite must be sent and completed before scheduling person interview."
        );
        return;
      }
      if (!this.person_form.interviewer_email) {
        this.root_notification("Please add interviewer email.");
        return;
      }
      if (!this.person_form.scheduled_at) {
        this.root_notification("Please select interview date and time.");
        return;
      }
      if (!this.person_form.duration_minutes) {
        this.root_notification("Please select interview duration.");
        return;
      }

      if (!this.person_form.ms_teams_link) {
        try {
          this.person_invite_submitting = true;
          this.person_invite_status_text =
            "Generating Microsoft Teams meeting link...";
          const startAt = new Date(this.person_form.scheduled_at).toISOString();
          const endAt = new Date(
            new Date(startAt).getTime() +
              Number(this.person_form.duration_minutes) * 60 * 1000
          ).toISOString();
          const teamsResponse = await generate_ms_teams_link({
            subject: `Person Interview - Candidate #${candidate_id}`,
            start_at: startAt,
            end_at: endAt
          });
          const teamsData = teamsResponse?.data?.data || {};
          this.person_form.ms_teams_link = teamsData.ms_teams_link || "";
          this.person_form.ms_teams_meeting_id = teamsData.ms_teams_meeting_id || "";
          this.person_form.ms_teams_join_meeting_id =
            teamsData.ms_teams_join_meeting_id || "";
          this.person_form.ms_teams_meeting_passcode =
            teamsData.ms_teams_meeting_passcode || "";
        } catch (e) {
          this.person_invite_submitting = false;
          this.person_invite_status_text = "";
          this.root_notification(
            "Unable to generate MS Teams link automatically. Please connect your Microsoft Teams account and try again."
          );
        }
      }

      if (!this.person_form.ms_teams_link) {
        return;
      }

      const roleFromStore =
        this.$store?.state?.recruiter?.view_candidates_dynamically?.job_title || "";
      const fallbackRole =
        roleFromStore || (isNaN(job_id) ? "Interview Role" : `Job #${job_id}`);
      const jobRole = await this.resolveInviteJobRole(
        isNaN(job_id) ? 0 : job_id,
        fallbackRole
      );
      const roomSeed = `${candidate_id}_${isNaN(job_id) ? "nojob" : job_id}_${new Date(
        this.person_form.scheduled_at
      ).getTime()}`;
      const platformRoomId = `hcms-final-${roomSeed}`;

      this.$store.dispatch(`recruiter_ai_interviews/${INIT_AI_INTERVIEW_INVITES}`);
      this.person_invite_submitting = true;
      this.person_invite_status_text = "Saving interview invite...";
      const invite = await this.$store.dispatch(
        `recruiter_ai_interviews/${SCHEDULE_AI_INTERVIEW_INVITE}`,
        {
          interview_type: "person",
          job_id: isNaN(job_id) ? null : job_id,
          job_role: jobRole,
          candidate_id,
          upload_response_id,
          candidate_name:
            this.data?.profile?.profile?.personal_details?.name &&
            Object.keys(this.data.profile.profile.personal_details.name).length > 0
              ? Object.values(this.data.profile.profile.personal_details.name)
                  .filter((v: any) => v)
                  .join(" ")
              : "Candidate",
          candidate_role: this.designation || "Candidate",
          avatar_uri: this.data?.user?.avatar_uri ?? null,
          interviewer_email: this.person_form.interviewer_email,
          ms_teams_link: this.person_form.ms_teams_link,
          ms_teams_meeting_id: this.person_form.ms_teams_meeting_id,
          ms_teams_join_meeting_id: this.person_form.ms_teams_join_meeting_id || null,
          ms_teams_meeting_passcode: this.person_form.ms_teams_meeting_passcode || null,
          platform_room_id: platformRoomId,
          duration_minutes: Number(this.person_form.duration_minutes),
          scheduled_at: new Date(this.person_form.scheduled_at).toISOString()
        }
      );

      if (invite) {
        let interviewerBrief: any = null;
        let questionBank: any[] = [];
        try {
          this.person_invite_status_text = "Fetching AI interview report...";
          const aiReportResp = await get_latest_interview_report(
            candidate_id,
            "ai",
            isNaN(job_id) ? null : job_id
          );
          const latestAiReport = aiReportResp?.data?.data?.ai_report || {};
          const resumeText =
            JSON.stringify(this.data?.profile?.profile || {}) || "Candidate resume";
          const jdText = await this.resolveMlJdText(
            isNaN(job_id) ? 0 : job_id,
            jobRole || "Interview role"
          );
          this.person_invite_status_text =
            "Generating interviewer question bank...";
          const questionResp = await generate_questions({
            entity: "ibhc",
            entity_id: `job_${isNaN(job_id) ? "001" : job_id}`,
            user_type: "recruiter",
            user_id: String(this.user_details.id || "hr_user"),
            resume_text: resumeText,
            jd_text: jdText,
            pre_interview_form: {},
            interviewer_email: this.person_form.interviewer_email
          });
          questionBank =
            questionResp?.data?.data?.question_bank ||
            questionResp?.data?.question_bank ||
            [];

          this.person_invite_status_text = "Generating interviewer guidelines...";
          const guidelinesResp = await generate_guidelines({
            ai_report: latestAiReport,
            question_bank: questionBank,
            resume_text: resumeText,
            asked_question_ids: []
          });
          interviewerBrief =
            guidelinesResp?.data?.data?.interviewer_brief ||
            guidelinesResp?.data?.interviewer_brief ||
            null;

          await upsert_interview_report({
            candidate_id,
            interview_type: "person",
            job_id: isNaN(job_id) ? null : job_id,
            thread_id: null,
            question_bank: questionBank,
            ai_report: latestAiReport,
            interviewer_brief: interviewerBrief,
            status: interviewerBrief ? "guidelines_generated" : "scheduled"
          });
        } catch (e) {
          // Scheduling should continue even if guideline generation fails.
        }
        try {
          this.person_invite_status_text = "Sending interviewer invite email...";
          const latestPersonReportResp = await get_latest_interview_report(
            candidate_id,
            "person",
            isNaN(job_id) ? null : job_id
          );
          const latestPersonBrief =
            latestPersonReportResp?.data?.data?.interviewer_brief || null;
          const latestQuestionBank =
            latestPersonReportResp?.data?.data?.question_bank || questionBank;
          await send_interviewer_meeting_invite({
            interviewer_email: this.person_form.interviewer_email,
            candidate_name: invite.candidate_name || "Candidate",
            job_role: jobRole,
            scheduled_at: new Date(this.person_form.scheduled_at).toISOString(),
            ms_teams_link: this.person_form.ms_teams_link,
            ms_teams_join_meeting_id: this.person_form.ms_teams_join_meeting_id || null,
            ms_teams_meeting_passcode: this.person_form.ms_teams_meeting_passcode || null,
            interviewer_brief: latestPersonBrief || interviewerBrief || null,
            question_bank: latestQuestionBank
          });
        } catch (_e) {
          this.root_notification(
            "Interview scheduled, but failed to send interviewer email invite."
          );
        }
        this.person_invite_submitting = false;
        this.person_invite_status_text = "";
        this.root_notification("Person interview invite scheduled.");
        this.closePersonDialog();
        await this.$router.push({ path: "/recruiter/interviews/person-agent" });
        return;
      }

      this.person_invite_submitting = false;
      this.person_invite_status_text = "";
      this.root_notification("Person interview invite already scheduled.");
    }
  }
});
